import type * as React from "react";
import { ReactNode } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GLTooltip from "components/v3/sharedComponents/GLTooltip";
import { COLORS } from "components/v3/Theme/colors";
import type { SxProps, Theme } from "@mui/material/styles";

export type GLFieldLabelProps = {
  label: string;
  required?: boolean;
  tooltip?: ReactNode;
  sx?: SxProps<Theme>;
};

const GLFieldLabel: React.FC<GLFieldLabelProps> = ({
  label,
  required = false,
  tooltip,
  sx
}) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        ...sx
      }}
    >
      <Typography variant="body_strong_black">{label}</Typography>

      {required ? (
        <Typography
          aria-hidden
          component="span"
          sx={{
            color: COLORS.NOTICE,
            fontSize: "1rem",
            lineHeight: 1,
            ml: 0.5
          }}
        >
          *
        </Typography>
      ) : (
        <Typography
          variant="body_xs_dark_gray"
          sx={{
            fontStyle: "italic",
            fontWeight: 400,
            marginLeft: "12px",
            marginTop: "3px"
          }}
        >
          (Optional)
        </Typography>
      )}

      {tooltip ? (
        <GLTooltip title={tooltip}>
          <IconButton size="small" sx={{ ml: "10px", p: 0 }}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </GLTooltip>
      ) : null}
    </Box>
  );
};

export default GLFieldLabel;
